import i18n from './../../../shared/i18n';
import BaseModel from "../../../core/components/input-widget/BaseModel";

export default class PaymentMethodForm extends BaseModel {
  payment_method = '';

  constructor(data = {}) {
    super();
    Object.assign(this, {...data});
  }

  rules = {
    payment_method: ''
  };

  attributeLabels = {
    payment_method: i18n.t('Payment Method'),
  };
}
